import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import ImmutablePropTypes from 'react-immutable-proptypes';
import SiteFields from './SiteFields';
import DiagnosticTabs, { getDefaultTab } from './DiagnosticTabs';
import DiagnosticForm from './DiagnosticForm';
import DiagnosticTools from './DiagnosticTools';

class SiteForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: getDefaultTab(props.site),
    };

    this._onTabChange = this._onTabChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    const { currentTab } = this.state;

    this.props.fetchDiagnostic(currentTab);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.currentTab !== this.state.currentTab ||
      prevProps.site.id !== this.props.site.id
    ) {
      this.props.fetchDiagnostic(this.state.currentTab);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.site.id !== this.props.site.id) {
      this.setState({
        currentTab: getDefaultTab(nextProps.site),
      });
    }
  }

  _onTabChange(val) {
    this.setState({
      currentTab: val,
    });
  }

  render() {
    const {
      site,
      workers,
      errors,
      products,
      units,
      onUpdate,
      isFetchingDiagnostic,
      diagnosticContent,
      serializeDiagnostic,
      mustSerializeDiagnostic,
      diagnosticTools,
      diagnosticErrors,
      addTool,
      updateTool,
      deleteTool,
      isNewCase,
      securityEpis,
      inventoryToPlan,
    } = this.props;

    const { currentTab } = this.state;

    const isFetching = isFetchingDiagnostic.has(currentTab);
    const mustSerialize = mustSerializeDiagnostic.has(currentTab);

    return (
      <div className="ui segment form">
        <h3 className="ui header">Informations</h3>
        <SiteFields
          site={site}
          errors={errors}
          workers={workers}
          onChange={onUpdate}
          isNewCase={isNewCase}
          securityEpis={securityEpis}
          inventoryToPlan={inventoryToPlan}
        />
        <DiagnosticTabs
          currentTab={currentTab}
          isFetching={isFetching}
          errors={diagnosticErrors}
          site={site}
          onChange={this._onTabChange}
        >
          {tab => (
            <div>
              <DiagnosticForm
                tab={tab}
                site={site}
                content={diagnosticContent.get(tab)}
                errors={diagnosticErrors.get(tab) || []}
                mustSerialize={mustSerialize}
                onSerialize={serializeDiagnostic}
              />
              {!isNewCase && <div className="ui hidden divider" />}
              {!isNewCase && (
                <DiagnosticTools
                  tab={tab}
                  units={units}
                  products={products.get(tab)}
                  tools={diagnosticTools.get(tab)}
                  onAdd={addTool}
                  onUpdate={updateTool}
                  onDelete={deleteTool}
                />
              )}
            </div>
          )}
        </DiagnosticTabs>
      </div>
    );
  }
}

SiteForm.propTypes = {
  site: PropTypes.object.isRequired,
  workers: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  products: ImmutablePropTypes.map.isRequired,
  units: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  isFetchingDiagnostic: ImmutablePropTypes.map.isRequired,
  fetchDiagnostic: PropTypes.func.isRequired,
  diagnosticContent: ImmutablePropTypes.map.isRequired,
  serializeDiagnostic: PropTypes.func.isRequired,
  mustSerializeDiagnostic: ImmutablePropTypes.map.isRequired,
  diagnosticTools: ImmutablePropTypes.map.isRequired,
  diagnosticErrors: ImmutablePropTypes.map.isRequired,
  addTool: PropTypes.func.isRequired,
  updateTool: PropTypes.func.isRequired,
  deleteTool: PropTypes.func.isRequired,
  isNewCase: PropTypes.bool,
};

export default SiteForm;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/SiteForm.js